package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent

object HeartbeatPulseAnimation {
    object Vars {
        val enlarge by StyleVariable<Number>(1.1)
    }

    val Frames = Keyframes {
        from { Modifier.scale(1) }
        30.percent { Modifier.scale(1) }
        40.percent { Modifier.scale(Vars.enlarge.value()) }
        50.percent { Modifier.scale(1) }
        60.percent { Modifier.scale(Vars.enlarge.value()) }
        70.percent { Modifier.scale(1) }
        to { Modifier.scale(1) }
    }
}